// extracted by css-extract-rspack-plugin
export default {"textarea":"tFYotM8f6E_XIA2K","label":"vnP1B8N2lCwApLgm","container":"bozlyBerL9oXUztK","wrapper":"bRKsuugFphgZRur6","copyButton":"gzkx_uibxBIWQwnr"};